import { useMemo } from 'react';

import { useAreAMACoorganizersEnabled, useIsAMACreationV2Enabled, useIsQuestionsOnlyMode } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventCreationPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventCreationPage'> = (
  options
) => {
  const askMeAnythingEventCreationPageOverrides = options?.overrides?.askMeAnythingEventCreationPage;

  const isAMACreationV2Enabled = useIsAMACreationV2Enabled();
  const areAMACoorganizersEnabled = useAreAMACoorganizersEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        coorganizers: false,
        ...askMeAnythingEventCreationPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMACreationV2Enabled,
      coorganizers: areAMACoorganizersEnabled,
      ...askMeAnythingEventCreationPageOverrides,
    };
  }, [askMeAnythingEventCreationPageOverrides, areAMACoorganizersEnabled, isAMACreationV2Enabled, isQuestionsOnlyMode]);
};
